import { useEffect, useState } from 'react';
import { useLocation } from 'react-router';

import { UpdatePasswordModalContext } from '../updatePasswordModalContext/UpdatePasswordModalContext';
import { User } from 'api/users/users.types';
import { AppRoute } from 'routing/AppRoute.enum';

import { UpdatePasswordModalContextControllerrProps } from './UpdatePasswordModalContextController.types';
import { UpdatePasswordContainer } from './updatePassword/UpdatePasswordContainer';

export const IS_UPDATE_PASSWORD_REQUIRED_KEY = 'isUpdatePasswordRequiredWebKD';

export const UpdatePasswordModalContextController = ({ children }: UpdatePasswordModalContextControllerrProps) => {
  const [isUpdatePasswordModalOpen, setIsUpdatePasswordModalOpen] = useState(true);
  const [user, setUser] = useState<User>();
  const location = useLocation();

  useEffect(() => {
    if (![AppRoute.login, AppRoute.base].includes(location.pathname as AppRoute)) {
      const isUpdatePasswordRequired = localStorage.getItem(IS_UPDATE_PASSWORD_REQUIRED_KEY) === 'true';

      setIsUpdatePasswordModalOpen(isUpdatePasswordRequired);
    }
  }, [location]);

  const handleUpdatePasswordModalOpen = (isModalOpen: boolean, user?: User) => {
    setIsUpdatePasswordModalOpen(isModalOpen);
    user && setUser(user);
  };

  return (
    <UpdatePasswordModalContext.Provider value={{ isUpdatePasswordModalOpen, handleUpdatePasswordModalOpen }}>
      {children}
      <UpdatePasswordContainer
        user={user}
        isModalOpen={isUpdatePasswordModalOpen}
        setIsModalOpen={setIsUpdatePasswordModalOpen}
        type="required"
        modalBackdropNotTransparent
      />
    </UpdatePasswordModalContext.Provider>
  );
};
